import { Tooltip } from "@chakra-ui/tooltip";

export function TooltipUsage({ children, label, color }) {
  return (
    <Tooltip hasArrow bg={color} placement="left-start" label={label} aria-label={label}>
      {children}
    </Tooltip>
  );
}
